export const setPasswordSchema = {
  body: {
    type: "object",
    properties: {
      password: { type: "string" },
      token: { type: "string", minLength: 1 },
    },
    required: ["password", "token"],
    additionalProperties: false,
  },
};

export const loginSchema = {
  body: {
    type: "object",
    properties: {
      email: { type: "string" },
      password: { type: "string" },
    },
    required: ["email", "password"],
  },
};

export const inviteSchema = {
  params: {
    type: "object",
    properties: {
      userPublicId: { type: "string" },
    },
    required: ["userPublicId"],
  },
};

export const getTokenSchema = {
  params: {
    type: "object",
    properties: {
      token: { type: "string" },
    },
    required: ["token"],
  },
};

export const emailRequiredSchema = {
  body: {
    type: "object",
    properties: {
      email: { type: "string" },
    },
    required: ["email"],
  },
};

export const getPasswordlessSchema = {
  querystring: {
    type: "object",
    properties: {
      token: { type: "string" },
    },
    required: ["token"],
  },
};

export const createPasswordlessSchema = {
  body: {
    type: "object",
    properties: {
      email: { type: "string" },
    },
    required: ["email"],
    additionalProperties: false,
  },
};

export const getPasswordlessTokenSchema = {
  params: {
    type: "object",
    properties: {
      token: { type: "string" },
    },
    required: ["token"],
  },
};

export const web_passwordlessSchema = {
  type: "object",
  properties: {
    email: { type: "string", minLength: 1, format: "email" },
    password: { type: ["string", "null"], maxLength: 0 },
  },
  required: ["email"],
  additionalProperties: false,
};

export const web_regularLoginSchema = {
  type: "object",
  properties: {
    email: { type: "string", minLength: 1, format: "email" },
    password: { type: "string", minLength: 6 },
  },
  required: ["email", "password"],
  additionalProperties: false,
};

export const web_confirmPasswordSchema = {
  type: "object",
  properties: {
    password: {
      type: "string",
      minLength: 3,
      pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$",
      // Require lowercase, uppercase, and digit
    },
    confirmPassword: {
      type: "string",
      const: { $data: "1/password" },
      // Ensure confirmPassword matches password
    },
  },
  required: ["password", "confirmPassword"],
  errorMessage: {
    properties: {
      password:
        "Password must contain at least 8 characters, a lowercase, an uppercase, and a digit",
      confirmPassword: "Passwords do not match",
    },
  },
};

export const mobile_passwordLoginSchema = {
  type: "object",
  properties: {
    email: { type: "string", minLength: 1 },
    password: { type: ["string"], minLength: 6 },
  },
  required: ["email", "password"],
  additionalProperties: false,
};

export const mobile_passwordlessLoginSchema = {
  type: "object",
  properties: {
    email: { type: "string", minLength: 1 },
    password: { type: ["string", "null"], maxLength: 0 },
  },
  required: ["email"],
  additionalProperties: false,
};

export const mobile_forgotPasswordSchema = {
  type: "object",
  properties: {
    email: { type: "string", minLength: 1 },
  },
  required: ["email"],
  additionalProperties: false,
};
